import { Component, OnInit } from '@angular/core';
import { Data, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { CommonserviceService } from 'src/app/common/services/commonservice.service'; // Import CommonserviceService
import { DataService } from 'src/app/common/services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  online: boolean = true;
  namcName: string = '';
  currentSection: number = 1;

  constructor(
    private readonly router: Router,
    private msalService: MsalService,
    private commonService: CommonserviceService,// Inject CommonserviceService
    private dataService: DataService,
  ) {
    window.addEventListener('online', () => {
      this.online = true;
    });
    window.addEventListener('offline', () => {
      this.online = false;
    });
    this.getStatus();
  }

  ngOnInit(): void {
    this.getNamcName();
    this.dataService.currentSection.subscribe(section => {
      this.currentSection = section;
     
    });
  }
  isIconsDisabled(): boolean {
   
    return this.currentSection === 3;
  }

  public gotoProfile(action: string): void {
    this.router.navigate(['manage-profile'], { queryParams: { action: `${action}` } });
  }

  public goToHome(): void {
    this.router.navigate(['home']);
  }

  getStatus() {
    setInterval(() => {
      this.online = navigator.onLine;
    }, 4000);
  }

  public logout(): void {
    this.msalService.logoutRedirect();
    sessionStorage.clear();
  }

  private getNamcName(): void {
    this.commonService.getNamc().subscribe({
      next: (response) => {
        this.namcName = response;
      },
      error: (error) => {
        console.error('getNacm Error:', error);
      }
    });
  }
}
